import React, {PropTypes} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { getScreen } from '../../../actions/screenAction';
import HeaderEnrichmentService from '../../../services/headerEnrichmentService';
import ScreenHeader from '../Subcomponents/ScreenHeader';
import ScreenInstructions from '../Subcomponents/ScreenInstructions';
import Consts from '../../../Consts';

class Spinner extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount(){
        if(this.props.values.RedirectUrl){
            document.location.href = this.props.values.RedirectUrl;
        }
    }

    render() {
        return (
                <div>
                    <div className="o-PageContainer--spinner ">
                        <img src={Consts.baseDir+"/images/spinner.gif"} />
                    </div>
                </div>

            );
    }
}

Spinner.propTypes = {
    name: React.PropTypes.string.isRequired,
    values: React.PropTypes.object.isRequired,
    uiSpec: React.PropTypes.object.isRequired,
    textResources: React.PropTypes.object.isRequired,
    actions: React.PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps){
    return {        
    };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({getScreen}, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Spinner);


/** WEBPACK FOOTER **
 ** ./src/components/ScreenComponents/Shared/Spinner.js
 **/